module.exports = __webpack_public_path__ + "img/tips-received.24f68c0a.png";